define([
    "dojo/_base/lang",
    "../../../constants/TypeConstants",
    "../properties/TypeProperty",
    "../properties/TagProperty",
    "../properties/EnabledProperty",
    "../properties/DescriptionProperty",
    "../properties/DescriptionOverrideProperty",
    "../properties/MnemonicProperty",
    "../properties/ShortcutProperty",
    "../properties/ActionIdProperty",
    "../properties/ValueProperty",
    "../properties/MinimumProperty",
    "../properties/MaximumProperty",
    "../properties/ErrorTextProperty",
    "../properties/WarningTextProperty",
    "../properties/ValidationStateProperty"
],
    function (lang, TypeConstants, TypeProperty, TagProperty, EnabledProperty, DescriptionProperty, DescriptionOverrideProperty, MnemonicProperty, ShortcutProperty, ActionIdProperty, ValueProperty, MinimumProperty, MaximumProperty, ErrorTextProperty, WarningTextProperty, ValidationStateProperty) {
        var hash = {};

        hash[TypeConstants.HORIZONTAL_SLIDER] = lang.mixin({}, {
            value: {
                type: "number",
                defaultValue: 5,
                notInAction: false,
                required: false
            },
            minimum: {
                type: "number",
                defaultValue: -10,
                notInAction: false,
                required: false
            },
            maximum: {
                type: "number",
                defaultValue: 10,
                notInAction: false,
                required: false
            },
            steps: {
                type: "number",
                defaultValue: 10,
                notInAction: false,
                required: false
            },

            numberOfTicks: {
                type: "number",
                defaultValue: 10,
                notInAction: false,
                required: false
            },
            labels: {
                type: "Array",
                notInAction: false,
                required: false,
                defaultValue: []

            },
            compact: {
                type: "boolean",
                defaultValue: false,
                notInAction: true,
                required: false 
            }
        }, TypeProperty, TagProperty, EnabledProperty, DescriptionProperty,
            DescriptionOverrideProperty, MnemonicProperty, ShortcutProperty, ActionIdProperty,
            ValueProperty, MinimumProperty, MaximumProperty, ErrorTextProperty, WarningTextProperty, ValidationStateProperty);

        return hash;
    });

